import React from "react";
import { UseCases } from "@planzone/core";
import {
  Allocation,
  Identifiable,
  List,
  Milestone,
  Project,
  Task,
  Event,
  Comment,
} from "@planzone/dto";

type Context = {
  project?: Identifiable<Project>;
  list?: Identifiable<List>;
  task?: Identifiable<Task>;
  milestone?: Identifiable<Milestone>;
  allocation?: Identifiable<Allocation>;
  event?: Identifiable<Event>;
  comment?: Identifiable<Comment>;
};

interface Props<UC extends UseCases[]> {
  useCases: UC;
  context?: Context;
  children(permissions: {
    [Key in `can${Capitalize<UC[number]>}`]: boolean;
  }): React.ReactNode;
}

enum Roles {
  Admin = "pz_admin",
  SubAdmin = "pz_under_admin",
  User = "pz_user",
  Visitor = "pz_visitor",

  ProjectManager = "pr_manager",
  Worker = "pr_worker",
  Observer = "pr_visitor",
}

export type { Props, Context };

export { Roles };
